import { Component } from "react";
import Navbar from "../Navbar";
import Hero from "../Hero";
import AboutUs from "../AboutUs";
import Services from "../Services";
import Gallery from "../Gallery";
import Appointment from "../Appointment";
import CallToAction from "../CallToAction";
import ContactUs from "../ContactUs";
import Footer from "../Footer";

class LandingPage extends Component {
  render() {
    return (
      <>
        <Navbar />
        <Hero />
        <AboutUs />
        <Services />
        <Gallery />
        <Appointment />
        <CallToAction />
        <ContactUs />
        <Footer />
      </>
    );
  }
}

export default LandingPage;
